export function changeInputStateFor(element, disabled) {
  $(element).find(':input')
    .prop('disabled', disabled)
    .trigger('chosen:updated');
}
